#!/usr/bin/env node

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

import { Command } from "commander";
import * as main from "./main";
import { Utilities } from "./utilities";

/* global process */

const program = new Command();

program
  .name("office-addin-manifest-converter")
  .description("CLI to the Office add-in manifest converter, XML to JSON")
  .usage("Usage: convert input-xml-manifest-path [--output <output-json-manifest-directory>] [-i] [-v]");

program
  .command("convert")
  .argument("<xml-manifest-file>")
  .combineFlagAndOptionalValue(false) // boolean flags can be combined together, such as '-ivd'
  .option("-o, --output <directory>", "path to the directory where the JSON manifest files will be written to")
  .option("-i, --image-download", "the root images color and outline should be downloaded into the output directory")
  // There was a change to stop supporting .file property on icons in the package so now we need to always
  // write image urls except for top level app icons that are in the main part of the manifest.
  // So, -u option is currently not used.
  // .option('-u, --image-urls', 'insert urls instead of package relative references for images that come from inside of the extension element.')
  .option("-v, --verbose", "extra log messages should be written to console")
  .option("-d, --debug", "show asserts and other debugging information")
  .option("--schema-override <url>", "the url that property $schema will be set to. Default is the latest public version schema that the converter supports. $schema and manifestVersion properties should be in sync.")
  .option("--schema-version-override <version>", "the version string that property manifestVersion will be set to. Default is the latest public version that the converter supports (ie \"1.17\" etc). $schema and manifestVersion properties should be in sync.")
  .action(async (xmlManifestFile: string, options: any): Promise<void> => {
    await convert(xmlManifestFile, options);
  });

program.parse();

async function convert(xmlManifestFile: string, options: any) {
  try {
    const output: string = options.output;
    const imageDownload: boolean = Utilities.isNullOrUndefined(options.imageDownload) ? false : options.imageDownload;
    const schemaOverride: string = Utilities.isNullOrUndefined(options.schemaOverride) ? null : options.schemaOverride;
    const schemaVersionOverride: string = Utilities.isNullOrUndefined(options.schemaVersionOverride) ? null : options.schemaVersionOverride;

    // Also see comment above.  imageUrls are now always written by default
    const verbose: boolean = Utilities.isNullOrUndefined(options.verbose) ? false : options.verbose;
    const dbg: boolean = Utilities.isNullOrUndefined(options.debug) ? false : options.debug;

    Utilities.setShowDebugInfo(dbg);
    Utilities.logDebug("Command line: convert " + xmlManifestFile + " " + JSON.stringify(options));

    await main.convert(xmlManifestFile, output, imageDownload, schemaOverride, schemaVersionOverride, verbose).catch((e) => {
      Utilities.logError(e);
    });

    Utilities.log("Convert is complete");
  } catch (err) {
    Utilities.logError(err);
  }
}